import type { SVGAttributes } from "react";

export function IcPickOnImg(props: SVGAttributes<SVGSVGElement>) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19 3C20.1 3 21 3.9 21 5V19C21 20.1 20.1 21 19 21H5C3.9 21 3 20.1 3 19V5C3 3.9 3.9 3 5 3H19ZM11.1426 17.5098L9 15.751L6 19H18L14.1426 14.875L11.1426 17.5098ZM12 6C10.2359 6 8.7998 7.401 8.7998 9.12207C8.79994 11.6236 12 14 12 14C12.025 13.9814 15.2001 11.6138 15.2002 9.12207C15.2002 7.40108 13.7641 6.00012 12 6ZM12 7.2002C13.1045 7.20029 14 8.09569 14 9.2002C13.9999 10.3046 13.1044 11.2001 12 11.2002C10.8955 11.2002 10.0001 10.3047 10 9.2002C10 8.09563 10.8954 7.2002 12 7.2002Z"
        fill="currentColor"
      />
    </svg>
  );
}
